import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Image } from 'antd-mobile'
import useCorpSettingStore from '@/stores/corp-setting'
import styles from './index.module.less'
import { cal, common, image, utils, uploadCommonEt } from '@/utils'
import downloadImageIcon from '@/assets/img/icon/download-image.png'

const { formatImgList, getListSimpleUrl, getAbsoluteUrl } = image
const { px2rem, getUuid } = utils

interface ProductCellProps {
  item: any
  corpId: string
  index: number
  cellWidth: string
}

const ProductCell: React.FC<ProductCellProps> = (props) => {
  const navigate = useNavigate()
  const { item, index, cellWidth, corpId } = props
  const { corpSetting } = useCorpSettingStore()
  const { currencySymbol: currency, priceOff } = corpSetting || {}
  const { cloudProduct = {} } = item
  const {
    productStatus,
    productId,
    productName,
    imageList = [],
    video,
    unitPriceArray = [],
  } = cloudProduct || {}
  const priceInfo = useMemo(() => unitPriceArray[0] || {}, [unitPriceArray])

  // 经过http处理后的图片地址
  const imageUrls = useMemo(() => {
    return formatImgList(imageList, video, 480)
  }, [imageList, video])

  // 获取首张缩略图片
  const imageUrlSimple = useMemo(() => {
    return getListSimpleUrl(imageUrls, 140)
  }, [imageUrls])

  const isMultiPrice = useMemo(
    () => (productStatus & 128) === 128,
    [productStatus],
  )

  const priceLabel = useMemo(() => {
    const { price, minPrice, maxPrice } = priceInfo || {}
    return isMultiPrice
      ? cal.getMoneyRange([minPrice, maxPrice])
      : String(cal.moneyFormat(price))
  }, [priceInfo, isMultiPrice])

  // 根据priceLabel的长度，定义不同的字体大小
  const fontSize = useMemo(() => {
    if (priceLabel.length > 10) {
      return px2rem(30)
    } else if (priceLabel.length > 7) {
      return px2rem(34)
    } else {
      return px2rem(40)
    }
  }, [priceLabel])

  const handleGoDetail = (productId: string) => {
    navigate(`/album/product-detail/${corpId}/${productId}`)
  }

  // 下载图片和视频
  const onDownloadFiles = (e: any) => {
    // 7.8.3需求埋点：点击下载按钮
    uploadCommonEt(13)

    // 阻止事件冒泡
    e.stopPropagation()
    // 获取货品的图片和视频
    let files: { url: string; type: 'image' | 'video'; name: string }[] =
      imageUrls.map((url) => ({
        url,
        type: 'image',
        name: getUuid() + '.jpg',
      }))

    // 视频转为绝对地址
    const videoTemp = getAbsoluteUrl(video)
    files = videoTemp
      ? files.concat({
          url: videoTemp,
          type: 'video',
          name: getUuid() + '.mp4',
        })
      : files
    common.downloadFiles(files)
  }

  return (
    <div
      className={styles['product-item']}
      key={index}
      onClick={() => handleGoDetail(productId)}
    >
      <div
        className={styles['img-wrap']}
        data-index={cellWidth}
        style={{ height: cellWidth }}
      >
        <Image
          src={imageUrlSimple}
          fit="cover"
          height={cellWidth}
          className={styles['preview-img']}
          lazy={true}
        ></Image>
      </div>

      <div className={styles['product-info']}>
        <h3 className={styles['title'] + ' ep-2'}>{productName || ''}</h3>

        <div className={styles['info-bottom']}>
          {
            !priceOff && 
              <div className={styles['price-wrap']}>
              <span className={styles['symbol']}>{currency}</span>
              <span className={styles['price']} style={{ fontSize }}>
                {priceLabel}
              </span>
              {priceInfo.unitName && (
                <span className={styles['unit']}>/{priceInfo.unitName}</span>
              )}
            </div>
          }

          <img
            src={downloadImageIcon}
            alt=""
            className={styles['download-image']}
            onClick={onDownloadFiles}
          />
        </div>
      </div>
    </div>
  )
}

export default ProductCell
